<template>
  <div class="contact">
    <div class="contact-channel" style="font-weight:600; font-size:30px">联系方式</div>
    <div class="contact-phone">电话：{{$zeroOneZeroPhone|| '010-58230628' }}（法定工作日：10:00-17:00）</div>
    <!-- 我要报名 -->
    <div class="contact-to-sign">
      <div class="dialogBut" @click="handleClick">火速报名</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  data() {
    return {
      dialogVisbility: false
    };
  },
  methods: {
    handleClick() {
      this.$emit("change", true)
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  height: 443px;
  background: #484848;
  display: flex;
  align-items: center;
  margin-top: 80px;
  flex-direction: column;
}
.contact-channel {
  font-size: 36px;
  color: #ffffff;
  margin-top: 75px;
}
.contact-phone {
  font-size: 18px;
  color: #ffffff;
  margin-top: 50px;
}
.contact-to-sign {
  margin-top: 50px;
  width: 193px;
  height: 50px;
  background: #f99b3a;
  border-radius: 25px;
  color: white;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
